import React from 'react';
import {withRouter} from 'react-router-dom';
import LayoutContainer from '../../components/LayoutContainer';
import Title from '../../components/Title';
import Box from '../../components/Box';
import Button from '../../components/Button';
import MainContainer from '../../components/MainContainer';
import Logo from '../../components/Logo';
import DisplayIban from '../../components/DisplayIban';
import ProgressBar from '../../components/ProgressBar';
import Input from '../../components/Input';
import Label from '../../components/Label';
import SubLabel from '../../components/SubLabel';
import {Field, Form, FormValidation, resetSubmitting} from '@nexios/frontend-forms';
import ErrorMessage from '../../components/ErrorMessage';
import FieldWrapper from '../../components/FieldWrapper';
import _ from 'lodash';
import {updateSession, cleanseAddress, cleanseName} from '../../reducer';
import {gaStep2} from '../../googleAnalytics/step2';
import {connect} from 'react-redux';
import Validation from '../../components/Validation';
import DateInput from '../../components/DateInput';
import Checkbox from '../../components/Checkbox';
import Backbutton from '../../components/Backbutton';
import RadioButtonContainer from '../../components/RadioButtonContainer';
import {Helmet} from 'react-helmet';
import Telemarketing from '../../components/Telemarketing';
import NewsletterOptIn from '../../components/NewsletterOptIn';
import {optInChoices, normalizeOptIns} from '../../utils/optIn';
import styled, {withTheme} from 'styled-components';
import useScrollToTop from '../../hooks/useScrollToTop';
import Teaser from '../../components/Teaser';
import ProductImage from '../../components/ProductImage';
import CollectingSideBar from '../../components/CollectingSideBar';
import formatPhone from '@nexios/phone-number-formatter';
import genders from '../../utils/genders';
import orderContactBlocks from '../../utils/orderContactBlocks';
import TextToHtml from '../../components/TextToHtml';
import ButtonContainer from '../../components/ButtonContainer';
import parseText from '../../utils/parseText';
import handleContentAction from '../../utils/handleContentAction';
import DonationBoxSideBar from '../../components/DonationBoxSideBar';
import DJSBSideBar from '../../components/DJSBSideBar';
import CollectingImage from '../../components/CollectingImage';
import Dropdown from '../../components/Dropdown';
import {AddressRow, StyledAddressLabel, HouseNumberRow, FoundAddress, FoundAddressTitle, NoFoundAddress} from '../../components/Address';

const hasValue = val => !_.isNil(val) && _.trim(val) !== '';

const isAddressVisible = ctx => {
  if (ctx.donateAsOrganisation === true) {
    return ctx.organisation.isAddressVisible;
  }

  return ctx.person.isAddressVisible;
};

const setChannels = (formContext, ctx, data) => {
  const channels = [];
  if (formContext.allowPreferredChannelWhatsApp && (data.donateAsOrganisation === true ? formContext.organisation.isTelephoneVisible : formContext.person.isTelephoneVisible)) {
    channels.push({
      label: 'WhatsApp',
      value: {
        icon: 'fa-whatsapp',
        value: 'whatsapp',
        title: 'WhatsApp'
      }
    });
  }
  if (formContext.allowPreferredChannelEmail) {
    channels.push({
      label: 'E-mail',
      value: {
        icon: 'fa-envelope-o',
        value: 'email',
        title: 'E-mail'
      }
    });
  }
  if (formContext.allowPreferredChannelNone) {
    channels.push({
      label: 'Liever niet',
      value: {
        icon: 'fa-times-circle-o',
        value: 'none',
        title: 'Liever niet'
      }
    });
  }
  ctx.setList('channels', channels);
  const allowedChannels = channels.map(channel => channel.value.value);
  if (!_.isNil(data.preferredChannel) && allowedChannels.indexOf(data.preferredChannel) === -1) {
    ctx.setValues({preferredChannel: null});
  }
};

const Step2 = ({
  formContext,
  dmBoxInfo,
  collectorInfo,
  save,
  history,
  cleanseAddress,
  cleanseName,
  gaStep2,
  resetSubmittingForm,
  next,
  previous,
  progressBar,
  isProductForm,
  theme
}) => {
  useScrollToTop();
  let cleansingAddress = false;
  let cleansingName = false;

  const Email = () => (
    <div className='marginBottom'>
      <Field
        label='E-mailadres'
        name='email'
        inputComponent={Input}
        component={FieldWrapper}
        placeholder='E-mailadres'
        inputType='email'
        autoComplete='email'
      />
      <NewsletterOptIn label={formContext.newsletterText} />
    </div>
  );

  const PersonForm = (props) => {
    const blocks = {
      gender: <Gender genderDisplay={props.genderDisplay} />,
      name: <Name isFirstNameVisible={props.isFirstNameVisible}
        isFirstNameRequired={props.isFirstNameRequired}
        isInitialsRequired={props.isInitialsRequired} />,
      address: <Address {...props} />,
      phone: <Phone {...props} />,
      dateOfBirth: <DateOfBirth />,
      email: <Email />
    };
    return <>{orderContactBlocks(formContext.person.fieldOrder, blocks).map(({key, node}) => <React.Fragment key={key}>{node}</React.Fragment>)}</>;
  };

  const formConfig = {
    onSubmit: () => {
      if (cleansingAddress || cleansingName) {
        resetSubmittingForm();
      } else {
        gaStep2(formContext);
        save([
          'dateOfBirth',
          'donateAsOrganisation',
          'email',
          'firstName',
          'initials',
          'infix',
          'lastName',
          'gender',
          'postalCode',
          'houseNumber_i',
          'houseNumberAddition',
          'street',
          'city',
          'renderAsPerson',
          'renderAsOrganisation',
          'telephone',
          'organisationName',
          'allowTelemarketing',
          'allowNewsletter',
          'preferredChannel'
        ], () => {
          history.push(`${next}${history.location.search}`);
        });
      }
    },
    onInit: (ctx) => {
      ctx.setDefaultValues({
        donateAsOrganisation: _.get(formContext, ['donateAsOrganisationDefault'], false)
      });

      ctx.setList('days', _.range(1, 31).map(value => ({label: `${value}`, value: `${value}`})));
      ctx.setList('genders', genders(formContext));
      ctx.setList('donateAsOrganisationChoices', [
        {label: 'Particulier', value: false},
        {label: 'Bedrijf', value: true}
      ]);
      ctx.setList('optInChoices', optInChoices);

      setChannels(formContext, ctx, ctx);

      if (formContext.newsletterOptIn === 'dropdown') {
        const newsletterDefault = _.get(formContext, 'newsletterDefault');
        if (newsletterDefault === true || newsletterDefault === false) {
          ctx.setDefaultValues({
            allowNewsletter: newsletterDefault
          });
        }
      } else if (_.get(formContext, 'newsletterDefault', theme.allowNewsletterDefault) === true) {
        ctx.setDefaultValues({
          allowNewsletter: true
        });
      }
      if (formContext.telemarketingOptIn === 'dropdown') {
        const telemarketingDefault = _.get(formContext, 'telemarketingDefault');
        if (telemarketingDefault === true || telemarketingDefault === false) {
          ctx.setDefaultValues({
            allowTelemarketing: telemarketingDefault
          });
        }
      } else if (formContext.telemarketingOptIn !== 'none' && _.get(formContext, 'telemarketingDefault', true) === true) {
        ctx.setDefaultValues({
          allowTelemarketing: true
        });
      }

      if (hasValue(formContext.step2BodyText)) {
        ctx.setValues({step2BodyText: parseText({...ctx, ...formContext}, formContext.step2BodyText)});
      }
    },
    onDataChanged: (ctx, callback) => {
      normalizeOptIns(ctx);
      setChannels(formContext, ctx, ctx.data);

      const donateAsOrganisation = _.get(ctx, [
        'data',
        'donateAsOrganisation'
      ]);
      const previousDonateAsOrganisation = _.get(ctx, [
        'previousData',
        'donateAsOrganisation'
      ]);

      if (donateAsOrganisation !== previousDonateAsOrganisation) {
        ctx.validate(true);
        return callback();
      }

      const postalCode = _.get(ctx, [
        'data',
        'postalCode'
      ]);
      const previousPostalCode = _.get(ctx, [
        'previousData',
        'postalCode'
      ]);
      const houseNumber = _.get(ctx, [
        'data',
        'houseNumber_i'
      ]);
      const previousHouseNumber = _.get(ctx, [
        'previousData',
        'houseNumber_i'
      ]);
      const houseNumberAddition = _.get(ctx, [
        'data',
        'houseNumberAddition'
      ]);
      const previousHouseNumberAddition = _.get(ctx, [
        'previousData',
        'houseNumberAddition'
      ]);

      let hasAddressChanged = false;

      if (postalCode !== previousPostalCode || houseNumber !== previousHouseNumber || houseNumberAddition !== previousHouseNumberAddition) {
        hasAddressChanged = true;
      }

      if (hasValue(postalCode) &&
        hasValue(houseNumber) &&
        hasAddressChanged) {

        // if we are already cleansing do not start again, request may interfer
        if (cleansingAddress) {
          return;
        }

        cleansingAddress = true;

        cleanseAddress({
          postalCode,
          houseNumber_i: houseNumber,
          houseNumberAddition
        }, (data) => {
          if (data.status === 500) {
            data = {
              result: {
                success: false
              },
              address: {
                street: '',
                city: ''
              }
            };
          }

          const addressCleansingStatus = _.get(data, [
            'result',
            'success'
          ], false) ? 'GREEN' : 'RED';

          const cleansedAddress = _.get(data, [
            'result',
            'address'
          ]);

          if (addressCleansingStatus === 'GREEN') {
            ctx.setValues({
              street: cleansedAddress.street,
              city: cleansedAddress.city,
              postalCode: cleansedAddress.postalCode,
              houseNumber_i: cleansedAddress.houseNumber_i,
              houseNumberAddition: cleansedAddress.houseNumberAddition,
              addressCleansingStatus
            });
          } else {
            ctx.setValues({
              street: null,
              city: null,
              addressCleansingStatus
            });
          }

          ctx.validate(true);

          cleansingAddress = false;

          return callback();
        });
      } else if (!hasValue(postalCode) || !hasValue(houseNumber)) {
        ctx.setValues({
          addressCleansingStatus: null,
          street: null,
          city: null
        });
      }

      const initials = _.get(ctx, [
        'data',
        'initials'
      ]);
      const previousInitials = _.get(ctx, [
        'previousData',
        'initials'
      ]);
      const firstName = _.get(ctx, [
        'data',
        'firstName'
      ]);
      const previousFirstName = _.get(ctx, [
        'previousData',
        'firstName'
      ]);
      const infix = _.get(ctx, [
        'data',
        'infix'
      ]);
      const previousInfix = _.get(ctx, [
        'previousData',
        'infix'
      ]);
      const lastName = _.get(ctx, [
        'data',
        'lastName'
      ]);
      const previousLastName = _.get(ctx, [
        'previousData',
        'lastName'
      ]);

      let hasNameChanged = initials !== previousInitials || firstName !== previousFirstName || infix !== previousInfix || lastName !== previousLastName;

      if (formContext.cleanseName && hasValue(lastName) && hasNameChanged) {
        // if we are already cleansing do not start again, request may interfere
        if (cleansingName) return;

        cleansingName = true;
        let name = {initials, firstName, infix, lastName};

        cleanseName({name}, cleanseNameResult => {
          const decisionStatus = _.get(cleanseNameResult, [
            'result',
            'decisionStatus'
          ]);

          ctx.setValues({
            nameCleansingStatus: decisionStatus
          });

          ctx.validate(true);
          cleansingName = false;

          return callback();
        });
      } else if (!hasValue(lastName)) {
        ctx.setValues({
          nameCleansingStatus: null
        });
      }

      const email = _.get(ctx, [
        'data',
        'email'
      ]);
      const previousEmail = _.get(ctx, [
        'previousData',
        'email'
      ]);

      if (hasValue(email) && email !== previousEmail) {
        ctx.setValues({
          email: _.trim(email)
        });
      }

      return callback();
    },
    fields: {
      telemarketingInfoText: {
        isVisible: ctx => {
          if (ctx.telemarketingOptIn !== 'text' && ctx.telemarketingOptIn !== 'button') {
            return false;
          }

          if (ctx.donateAsOrganisation === true) {
            return ctx.organisation.isTelephoneVisible;
          }

          return ctx.person.isTelephoneVisible;
        },
        isRequired: false
      },
      allowNewsletter: {
        isVisible: () => {
          return formContext.allowNewsletter === true && formContext.allowNewsletterDisplay === 'step2' && formContext.donationPageType !== '12_donationAnon';
        }
      },
      allowTelemarketing: {
        isVisible: ctx => {
          if (formContext.telemarketingOptIn !== 'checkbox' && formContext.telemarketingOptIn !== 'dropdown') {
            return false;
          }

          if (ctx.donateAsOrganisation === true) {
            return ctx.organisation.isTelephoneVisible;
          }

          return ctx.person.isTelephoneVisible;
        },
        isRequired: false
      },
      renderAsOrganisation: {
        isVisible: ctx => ctx.donateAsOrganisation === true
      },
      renderAsPerson: {
        isVisible: ctx => ctx.donateAsOrganisation !== true
      },
      donateAsOrganisation: {
        isVisible: (ctx) => ctx.allowDonateAsOrganisation === true
      },
      organisationName: {
        isVisible: ctx => ctx.donateAsOrganisation === true,
        isRequired: true,
        rules: [
          {
            isValid: ctx => !_.isNil(ctx.organisationName) && _.trim(ctx.organisationName) !== '',
            message: theme.showRequiredText && 'Naam organisatie is niet ingevuld'
          }
        ]
      },
      email: {
        isVisible: true,
        isRequired: true,
        rules: [
          {
            isValid: ctx => !_.isNil(ctx.email) && ctx.email !== '',
            message: theme.showRequiredText && 'E-mailadres is niet ingevuld'
          },
          {
            isValid: ctx => {
              if (_.isNil(ctx.email) || ctx.email === '') {
                return true;
              }

              return /^[-0-9a-zA-Z.+_]{1,63}@([-0-9a-zA-Z+_]+\.){1,63}[a-zA-Z]{1,63}$/.test(_.trim(ctx.email));
            },
            message: 'Er is geen geldig e-mailadres ingevuld.'
          }
        ]
      },
      gender: {
        isVisible: ctx => ctx.donateAsOrganisation !== true && ctx.person.isGenderVisible === true,
        isRequired: ctx => ctx.donateAsOrganisation !== true && ctx.person.isGenderRequired === true,
        rules: [
          {
            isValid: ctx => {
              if (ctx.donateAsOrganisation === true) {
                return true;
              }

              if (ctx.person.isGenderRequired) {
                return !_.isNil(ctx.gender) && _.trim(ctx.gender) !== '';
              }

              return true;
            },
            message: theme.showRequiredText && 'Geslacht is niet ingevuld'
          }
        ]
      },
      initials: {
        isVisible: ctx => {
          if (ctx.donateAsOrganisation === true) {
            return ctx.organisation.isInitialsVisible;
          }

          return ctx.person.isInitialsVisible;
        },
        isRequired: ctx => {
          if (ctx.donateAsOrganisation === true) {
            return ctx.organisation.isInitialsRequired;
          }

          return ctx.person.isInitialsRequired;
        },
        rules: [
          {
            isValid: ctx => {
              if (ctx.donateAsOrganisation === true && ctx.organisation.isInitialsRequired) {
                return !_.isNil(ctx.initials) && _.trim(ctx.initials) !== '';
              }

              if (ctx.donateAsOrganisation !== true && ctx.person.isInitialsRequired) {
                return !_.isNil(ctx.initials) && _.trim(ctx.initials) !== '';
              }

              return true;
            },
            message: theme.showRequiredText && 'Voorletters is niet ingevuld'
          },
          {
            severity: 'warning',
            isValid: ctx => ctx.nameCleansingStatus === 'GREEN' || _.isEmpty(ctx.nameCleansingStatus)
          }
        ]
      },
      firstName: {
        isVisible: ctx => {
          if (ctx.donateAsOrganisation === true) {
            return ctx.organisation.isFirstNameVisible;
          }

          return ctx.person.isFirstNameVisible;
        },
        isRequired: ctx => {
          if (ctx.donateAsOrganisation === true) {
            return ctx.organisation.isFirstNameRequired;
          }

          return ctx.person.isFirstNameRequired;
        },
        rules: [
          {
            isValid: ctx => {
              if (ctx.donateAsOrganisation === true && ctx.organisation.isFirstNameRequired) {
                return !_.isNil(ctx.firstName) && _.trim(ctx.firstName) !== '';
              }

              if (ctx.donateAsOrganisation !== true && ctx.person.isFirstNameRequired) {
                return !_.isNil(ctx.firstName) && _.trim(ctx.firstName) !== '';
              }

              return true;
            },
            message: theme.showRequiredText && 'Voornaam is niet ingevuld'
          },
          {
            isValid: ctx => {
              if (_.isNil(ctx.firstName) || ctx.firstName === '') {
                return true;
              }

              return _.trim(ctx.firstName).length > 1;
            },
            message: 'Voornaam moet minimaal 2 karakters hebben.'
          },
          {
            severity: 'warning',
            isValid: ctx => ctx.nameCleansingStatus === 'GREEN' || _.isEmpty(ctx.nameCleansingStatus)
          }
        ]
      },
      infix: {
        rules: [
          {
            severity: 'warning',
            isValid: ctx => ctx.nameCleansingStatus === 'GREEN' || _.isEmpty(ctx.nameCleansingStatus)
          }
        ]
      },
      lastName: {
        rules: [
          {
            isValid: ctx => !_.isNil(ctx.lastName) && ctx.lastName !== '',
            message: theme.showRequiredText && 'Achternaam is niet ingevuld'
          },
          {
            isValid: ctx => {
              if (_.isNil(ctx.lastName) || ctx.lastName === '') {
                return true;
              }

              return _.trim(ctx.lastName).length > 1;
            },
            message: 'Achternaam moet minimaal 2 karakters hebben.'
          },
          {
            message: () => formContext.cleanseNameMessage || 'Naam is mogelijk niet juist.',
            severity: 'warning',
            isValid: ctx => ctx.nameCleansingStatus === 'GREEN' || _.isEmpty(ctx.nameCleansingStatus)
          }
        ]
      },
      postalCode: {
        isVisible: isAddressVisible,
        isRequired: ctx => {
          if (hasValue(ctx.houseNumber_i) || hasValue(ctx.houseNumberAddition)) {
            return true;
          }

          if (ctx.donateAsOrganisation === true) {
            return ctx.organisation.isAddressRequired;
          }

          return ctx.person.isAddressRequired;
        },
        rules: [
          {
            isValid: ctx => {
              if (!hasValue(ctx.postalCode)) {
                return true;
              }

              return /^[1-9][0-9]{3}\W?[a-zA-Z]{2}$/.test(_.trim(ctx.postalCode));
            },
            message: 'Er is geen geldige postcode ingevuld.'
          },
          {
            isValid: ctx => {
              if (hasValue(ctx.houseNumber_i) || hasValue(ctx.houseNumberAddition)) {
                return hasValue(ctx.postalCode);
              }

              if (ctx.donateAsOrganisation === true && ctx.organisation.isAddressRequired) {
                return hasValue(ctx.postalCode);
              }

              if (ctx.donateAsOrganisation !== true && ctx.person.isAddressRequired) {
                return hasValue(ctx.postalCode);
              }

              return true;
            },
            message: theme.showRequiredText && 'Postcode is niet ingevuld'
          },
          {
            message: 'Het opgegeven adres kan niet worden gevonden.',
            isValid: ctx => ctx.addressCleansingStatus !== 'RED'
          }
        ]
      },
      houseNumber_i: {
        isVisible: isAddressVisible,
        isRequired: ctx => {
          if (hasValue(ctx.postalCode) || hasValue(ctx.houseNumberAddition)) {
            return true;
          }

          if (ctx.donateAsOrganisation === true) {
            return ctx.organisation.isAddressRequired;
          }

          return ctx.person.isAddressRequired;
        },
        rules: [
          {
            isValid: ctx => ctx.addressCleansingStatus !== 'RED'
          },
          {
            isValid: ctx => {
              if (!hasValue(ctx.houseNumber_i)) {
                return true;
              }

              return ctx.houseNumber_i.length < 8 && /^\d*$/.test(ctx.houseNumber_i);
            },
            message: 'Er is geen geldig huisnummer ingevuld. Controleer of er alleen cijfers gebruikt zijn.'
          },
          {
            isValid: ctx => {
              if (hasValue(ctx.postalCode) || hasValue(ctx.houseNumberAddition)) {
                return hasValue(ctx.houseNumber_i);
              }

              if (ctx.donateAsOrganisation === true && ctx.organisation.isAddressRequired) {
                return hasValue(ctx.houseNumber_i);
              }

              if (ctx.donateAsOrganisation !== true && ctx.person.isAddressRequired) {
                return hasValue(ctx.houseNumber_i);
              }

              return !(ctx.addressCleansingStatus === 'RED' && !_.isNil(ctx.houseNumber_i));
            },
            message: theme.showRequiredText && 'Huisnummer is niet ingevuld'
          }
        ]
      },
      houseNumberAddition: {
        isVisible: isAddressVisible
      },
      telephone: {
        isVisible: ctx => {
          if (ctx.donateAsOrganisation === true) {
            return ctx.organisation.isTelephoneVisible;
          }

          return ctx.person.isTelephoneVisible;
        },
        isRequired: ctx => {
          if (ctx.preferredChannel === 'whatsapp') {
            return true;
          }
          if (ctx.donateAsOrganisation === true) {
            return ctx.organisation.isTelephoneRequired;
          }

          return ctx.person.isTelephoneRequired;
        },
        rules: [
          {
            isValid: ctx => {
              if (ctx.preferredChannel === 'whatsapp') {
                return hasValue(ctx.telephone);
              }

              if (ctx.donateAsOrganisation === true && ctx.organisation.isTelephoneRequired) {
                return hasValue(ctx.telephone);
              }

              if (ctx.donateAsOrganisation !== true && ctx.person.isTelephoneRequired) {
                return hasValue(ctx.telephone);
              }

              return true;
            },
            message: theme.showRequiredText && 'Telefoonnummer is niet ingevuld'
          },
          {
            isValid: ctx => {
              if (!hasValue(ctx.telephone)) {
                return true;
              }

              return formatPhone(ctx.telephone).result === 'GREEN';
            },
            message: 'Er is geen geldig telefoonnummer ingevuld.'
          }
        ]
      },
      dateOfBirth: {
        isVisible: ctx => ctx.donateAsOrganisation !== true && ctx.person.isDateOfBirthVisible,
        isRequired: ctx => {
          if (ctx.donateAsOrganisation !== true) {
            return ctx.person.isDateOfBirthRequired;
          }

          return false;
        },
        rules: [
          {
            isValid: ctx => {
              if (ctx.donateAsOrganisation === true) {
                return true;
              }

              if (ctx.person.isDateOfBirthRequired) {
                return hasValue(ctx.dateOfBirth);
              }

              return true;
            },
            message: theme.showRequiredText && 'Geboortedatum is niet ingevuld'
          }
        ]
      },
      street: {
        isVisible: ctx => ctx.addressCleansingStatus === 'GREEN' && isAddressVisible(ctx)
      },
      city: {
        isVisible: ctx => ctx.addressCleansingStatus === 'GREEN' && isAddressVisible(ctx)
      },
      noAddress: {
        isVisible: ctx => ctx.addressCleansingStatus !== 'GREEN' && isAddressVisible(ctx)
      },
      preferredChannel: {
        rules: [
          {
            isValid: ctx => {
              // Not asked?
              if (!ctx.allowPreferredChannel) {
                return true;
              }

              // no options available?
              if (!ctx.allowPreferredChannelWhatsApp && !ctx.allowPreferredChannelEmail && !ctx.allowPreferredChannelNone) {
                return true;
              }

              return !_.isNil(ctx.preferredChannel);
            },
            message: 'Selecteer hoe je geïnformeerd wilt worden.'
          }
        ]
      },
      donationReason: {
        isVisible: true,
        isRequired: true
      }
    }
  };

  const OrganisationForm = (props) => {
    const blocks = {
      organisationName: <OrganisationName />,
      address: <Address {...props} />,
      name: <Name isFirstNameVisible={props.isFirstNameVisible}
        isFirstNameRequired={props.isFirstNameRequired}
        isInitialsRequired={props.isInitialsRequired} />,
      email: <Email />,
      phone: <Phone {...props} />
    };
    return <>{orderContactBlocks(formContext.organisation.fieldOrder, blocks).map(({key, node}) => <React.Fragment key={key}>{node}</React.Fragment>)}</>;
  };

  return <>
    <Helmet>
      <title>{(formContext.isDonationBox && dmBoxInfo?.boxHeader_txt) || formContext.contactDataBrowserTitle}</title>
    </Helmet>
    <MainContainer
      backgroundImageUrl={theme?.donationBox?.imageAsBackground && formContext.isDonationBox && dmBoxInfo?.image?.publicUrl
        ? dmBoxInfo.image.publicUrl
        : formContext.backgroundImageUrl}
      backgroundImageTabletUrl={theme?.donationBox?.imageAsBackground && formContext.isDonationBox && dmBoxInfo?.image?.publicUrl
        ? dmBoxInfo.image.publicUrl
        : formContext.backgroundImageTabletUrl}
      backgroundImageMobileUrl={theme?.donationBox?.imageAsBackground && formContext.isDonationBox && dmBoxInfo?.image?.publicUrl
        ? dmBoxInfo.image.publicUrl
        : formContext.backgroundImageMobileUrl}
    />
    <LayoutContainer
      showCollectingWidget={formContext.showCollectingWidget || formContext.isDonationBox}
      position={formContext.textPosition}
      header={<div>
        <div style={{float: 'left', display: 'inline-block'}}>
          <Logo url={formContext.websiteUrl} />
        </div>
        {formContext.isCollecting && theme?.collecting?.imageTopRight &&
          <div style={{float: 'right', display: 'inline-block'}}><CollectingImage collectorInfo={collectorInfo} /></div>}
        <DisplayIban iban='NL08 INGB 0000 0005 55' />
      </div>}
      content={<Box position={formContext.textPosition}
        hasTeaser={!theme.teaser.hideOnStep2 && (!_.isNil(formContext.pageTeaserHeader) || !_.isNil(formContext.pageTeaserBodyText) || !_.isEmpty(formContext.pageTeaserCarouselItems))}>
        <Title title={theme.step2WidgetHeaderText || formContext.step2Header} showLogo={theme.title?.showLogoStep2}><ProgressBar progress={progressBar} /></Title>
        <Form
          autoComplete='on'
          formInstanceKey='donate'
          formContext={formContext}
          formConfig={formConfig}>
          {!theme?.error?.showBelowBodyText && <FormValidation
            component={ErrorMessage}
            errorMessageTemplate={formContext.errorMessageTemplate}
            formContext={formContext}
            errorMessage='Je hebt nog niet alle velden ingevuld.' />}
          <div className='widgetContent'>
            <div onClick={handleContentAction({history})}>
              <Field
                component={({value}) => <TextToHtml text={value} />}
                name='step2BodyText' />
            </div>
            {theme?.error?.showBelowBodyText && <FormValidation
              component={ErrorMessage}
              errorMessageTemplate={formContext.errorMessageTemplate}
              formContext={formContext}
              errorMessage='Je hebt nog niet alle velden ingevuld.' />}
            {_.get(formContext, ['donateAsOrganisationDisplay']) === 'radiobutton'
              ? <div className='marginBottom'><Field
                name='donateAsOrganisation'
                list='donateAsOrganisationChoices'
                label={_.get(formContext, ['donateAsOrganisationLabel'], 'Ik doneer als')}
                component={FieldWrapper}
                inputComponent={(props) => (
                  <RadioButtonContainer
                    fieldName='donateAsOrganisation'
                    valueName='donateAsOrganisation'
                    list={props.list}
                    {...props}
                    setValue={(v) => props.setValue(v === true || v === 'true')} />
                )}
              /></div>
              : <Field
                name='donateAsOrganisation'
                label={_.get(formContext, ['donateAsOrganisationLabel'], 'Doneer als organisatie')}
                component={FieldWrapper}
                inputComponent={Checkbox}
                hideLabel
              />}
            <Field
              name='renderAsPerson'
              telemarketingOptIn={formContext.telemarketingOptIn}
              telemarketingInfoText={formContext.telemarketingInfoText}
              telemarketingCheckBoxText={formContext.telemarketingCheckBoxText}
              isAddressVisible={formContext.person.isAddressVisible}
              isAddressOptional={!formContext.person.isAddressRequired}
              isFirstNameVisible={formContext.person.isFirstNameVisible}
              isFirstNameRequired={formContext.person.isFirstNameRequired}
              isInitialsRequired={formContext.person.isInitialsRequired}
              genderDisplay={formContext.genderDisplay}
              component={PersonForm}
            />
            <Field
              name='renderAsOrganisation'
              telemarketingOptIn={formContext.telemarketingOptIn}
              telemarketingInfoText={formContext.telemarketingInfoText}
              telemarketingCheckBoxText={formContext.telemarketingCheckBoxText}
              isAddressVisible={formContext.organisation.isAddressVisible}
              isAddressOptional={!formContext.organisation.isAddressRequired}
              isFirstNameVisible={formContext.organisation.isFirstNameVisible}
              isFirstNameRequired={formContext.organisation.isFirstNameRequired}
              isInitialsRequired={formContext.organisation.isInitialsRequired}
              component={OrganisationForm}
            />
            {formContext.allowPreferredChannel === true && <div className='marginBottom'>
              <TextToHtml text={formContext.preferredChannelTextHtml_txt} />
              <Field
                list='channels'
                name='preferredChannel'
                component={(props) => {
                  const list = props.list.map(a => {
                    a.label = null;
                    a.icon = a.value.icon;
                    a.title = a.value.title;
                    a.value = a.value.value;
                    return a;
                  });
                  return <div className='marginBottom amountButtons'>
                    <Field name='preferredChannel' component={Validation} />
                    <ButtonContainer
                      fieldName='preferredChannel'
                      valueName='preferredChannel'
                      list={list} /></div>;
                }}
              />
            </div>}

            <div className={'donationReason'} aria-hidden='true'>
              <Field
                name='donationReason'
                component={FieldWrapper}
                inputComponent={Input}
                label={'Reden donatie'}
                placeholder={'Reden donatie'}
                hideValidation
                tabIndex={'-1'}
                autoComplete={'e0e3896c-f25b-422d-8da1-bdc2466652d8'}
              />
            </div>

            <div className='marginBottom'>
              <FormValidation
                type='submit'
                label={!_.isNil(formContext.contactDataCallToActionLabel) ? formContext.contactDataCallToActionLabel : isProductForm ? 'Volgende stap' : 'Doneer nu'}
                component={Button}
              />
            </div>
            {formContext.telemarketingOptIn === 'button' && <Telemarketing
              telemarketingOptIn={formContext.telemarketingOptIn}
              telemarketingInfoText={formContext.telemarketingInfoText}
              telemarketingCheckBoxText={formContext.telemarketingCheckBoxText}
            />}
            <div>
              <Backbutton label={formContext.backButtonLabel} link={`${previous}${history.location.search}`} />
            </div>
          </div>
        </Form>
      </Box>}
      sidebar={
        <>
          {theme?.djsb?.showDJSB && <DJSBSideBar formContext={formContext} />}
          {isProductForm && <ProductImage url={_.get(formContext, ['productImageUrl'])} collapseIfEmpty />}
          {formContext.showCollectingWidget
            ? <CollectingSideBar collectorInfo={collectorInfo}><Teaser header={formContext.pageTeaserHeader} body={formContext.pageTeaserBodyText} formContext={formContext} /></CollectingSideBar>
            : formContext.isDonationBox
              ? <DonationBoxSideBar dmBoxInfo={dmBoxInfo} header={formContext.pageTeaserHeader} body={formContext.pageTeaserBodyText}>
                <Teaser header={formContext.pageTeaserHeader} body={formContext.pageTeaserBodyText} formContext={formContext} />
              </DonationBoxSideBar>
              : !theme.teaser.hideOnStep2 && <Teaser header={formContext.pageTeaserHeader} body={formContext.pageTeaserBodyText} formContext={formContext} />}
        </>
      }
      footer={formContext.footer}
      formContext={formContext}
      step={'2'}
    />
  </>;
};

const mapStateToProps = (state) => {
  return {
    formContext: state.reducer.formContext,
    isProductForm: state.reducer.isProductForm
  };
};

const mapDispatchToProps = (dispatch) => ({
  save: (fields, callback) => {
    dispatch(updateSession(fields, {
      isStep2Completed: true
    }, callback));
  },
  gaStep2: (formContext) => {
    dispatch(gaStep2(formContext));
  },
  cleanseAddress: (data, callback) => {
    dispatch(cleanseAddress(data, callback));
  },
  cleanseName: (data, callback) => {
    dispatch(cleanseName(data, callback));
  },
  resetSubmittingForm: () => dispatch(resetSubmitting('donate'))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTheme(Step2)));

function Address(props) {
  if (!props.isAddressVisible) return <></>;
  return (
    <>
    <div className='marginBottom'>
      <StyledAddressLabel>
        <Label label='Adres' isOptional={props.isAddressOptional} />
      </StyledAddressLabel>
      <AddressRow>
        <div>
          <Field
            name='postalCode'
            component={() => <SubLabel label='Postcode' />}
            hideValidation
          />
          <Field
            name='postalCode'
            component={FieldWrapper}
            inputComponent={Input}
            placeholder={'Postcode'}
            inline
            hideValidation
            autoComplete='postal-code'
          />
        </div>
        <div>
          <HouseNumberRow>
            <Field
              name='houseNumber_i'
              component={() => <SubLabel label='Huisnummer' />}
              hideValidation
            />
            <Field
              name='houseNumberAddition'
              component={() => <SubLabel label='Toevoeging' isOptional />}
              hideValidation
            />
          </HouseNumberRow>
          <HouseNumberRow>
            <Field
              name='houseNumber_i'
              component={FieldWrapper}
              inputComponent={Input}
              placeholder={'Huisnummer'}
              inline
              hideValidation
              inputType='tel'
              autoComplete='05d2ae54-5b99-4418-9d38-fde0ab6d553f'
            />
            <Field
              name='houseNumberAddition'
              component={FieldWrapper}
              inputComponent={Input}
              placeholder={'Toevoeging'}
              hideValidation
              autoComplete='f1a99033-6af3-4aa2-94db-1de7ff1af61d'
            />
          </HouseNumberRow>
        </div>
      </AddressRow>
      <Field
        name='postalCode'
        component={Validation} />
      <Field
        name='houseNumber_i'
        component={Validation} />
      <Field
        name='houseNumberAddition'
        component={Validation} />
      <FoundAddress>
        <FoundAddressTitle>Adres:</FoundAddressTitle>
        <Field name='noAddress' component={() => <NoFoundAddress>Wordt automatisch aangevuld</NoFoundAddress>} />
        <Field
          component={({value}) => <div className='addressBox'>{value}&nbsp;</div>}
          name='street' />
        <Field
          component={({value}) => <div className='addressBox'>{value}</div>}
          name='city' />
      </FoundAddress>
    </div>
    </>
  );
}

const Phone = (props) => {
  return <>
    <div className='marginBottom'>
      <Field
        label='Telefoonnummer'
        name='telephone'
        component={FieldWrapper}
        inputComponent={Input}
        placeholder='Telefoonnummer'
        inputType='tel'
        autoComplete='tel'
      />
      {(props.telemarketingOptIn === 'text' || props.telemarketingOptIn === 'checkbox' || props.telemarketingOptIn === 'dropdown') && <Telemarketing {...props} />}
    </div>
  </>;
};

const DateOfBirth = () => (
  <div className='marginBottom'>
    <Field
      label='Geboortedatum'
      name='dateOfBirth'
      component={FieldWrapper}
      inputComponent={DateInput}
      autoComplete='e41c45bd-94c9-45d5-aaaf-0fd215a44d18'
    />
  </div>
);

const Gender = ({genderDisplay}) => (
  <div className='marginBottom'>
    <Field
      label='Geslacht'
      name='gender'
      list='genders'
      component={FieldWrapper}
      inputComponent={(props) => {
        return genderDisplay === 'dropdown'
          ? <Dropdown fieldName='gender' valueName='gender' {...props} placeholder='Kiezen...' />
          : <RadioButtonContainer fieldName='gender' valueName='gender' list={props.list} {...props} />;
      }}
    />
  </div>
);

const NameRow = styled.div`
  display: flex;
  gap: ${props => props.theme.horizontalFieldGap || '5px'};

  > * {
    flex: 1;

    &:last-child {
      flex: ${props => props.theme.nameRow?.lastNameFlex || '3'};
    }
  }
`;
const Name = (props) => (
  <div className='marginBottom'>
    <Label label={'Naam'} />
    {props.isFirstNameVisible && <div className='marginBottomTen'>
      <Field
        name='firstName'
        component={FieldWrapper}
        inputComponent={Input}
        placeholder={'Voornaam'}
        hideValidation
        autoComplete='given-name'
      />
    </div>}
    <NameRow>
      <Field
        name='initials'
        component={() => <SubLabel label='Voorletters' isOptional={!props.isInitialsRequired} />}
        hideValidation
      />
      <Field
        name='infix'
        component={() => <SubLabel label='Tussenvoegsel' isOptional />}
        hideValidation
      />
      <Field
        name='lastName'
        component={() => <SubLabel label='Achternaam' />}
        hideValidation
      />
    </NameRow>
    <NameRow>
      <Field
        name='initials'
        component={FieldWrapper}
        inputComponent={Input}
        placeholder={'Voorletters'}
        hideValidation
        inline
        autoComplete='49989326-3fcd-4f40-9f3c-67ad6f1b1fa9'
      />
      <Field
        name='infix'
        component={FieldWrapper}
        inputComponent={Input}
        placeholder={'Tussenvoegsel'}
        hideValidation
        autoComplete='90ab3315-3929-4643-b78d-9de3e727eadf'
      />
      <Field
        name='lastName'
        component={FieldWrapper}
        inputComponent={Input}
        placeholder={'Achternaam'}
        hideValidation
        autoComplete='family-name'
      />
    </NameRow>
    <Field
      name='firstName'
      component={Validation} />
    <Field
      name='initials'
      component={Validation} />
    <Field
      name='infix'
      component={Validation} />
    <Field
      name='lastName'
      component={Validation} />
  </div>
);

const OrganisationName = () => (
  <div className='marginBottom'>
    <Field
      label='Naam organisatie'
      name='organisationName'
      inputComponent={Input}
      component={FieldWrapper}
      placeholder='Naam organisatie'
      autoComplete='3031d027-4735-4604-9fa5-337235fe7798'
    />
  </div>
);
